import { render } from "./SitesPublicView.vue?vue&type=template&id=048ca1f6&scoped=true"
import script from "./SitesPublicView.vue?vue&type=script&lang=js"
export * from "./SitesPublicView.vue?vue&type=script&lang=js"

import "./SitesPublicView.vue?vue&type=style&index=0&id=048ca1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ca1f6"]])

export default __exports__